<template>
    <div>
        <!-- 转仓申请 -->
        <el-dialog title="新增采购单" :visible.sync="addApplyVisible" width="1050px" :close-on-click-modal="false" center>
            <el-steps :active="activeStep" finish-status="success" simple style="margin-top: 1px">
                <el-step title="预创建采购单"></el-step>
                <el-step title="补充采购单sku单价(元)"></el-step>
            </el-steps>
            <div style="min-height:400px;">
                <!-- 第一步 -->
                <div style="padding:20px 20px;border:1px solid #ddd;" v-if="activeStep==1">
                    <el-form :inline="true">
                        <el-form-item label="采购单名称">
                            <el-input v-model="orderForm.name" placeholder="请填写采购单名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="采购单号">
                            <el-input v-model="orderForm.purchaseNo" placeholder="采购单号" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="预计到货日期">
                            <div class="block">
                                <el-date-picker v-model="orderForm.expectedArriveTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                            </div>
                        </el-form-item>
                        <el-form-item label="备注">
                            <el-input v-model="orderForm.remark" placeholder="请填写备注" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="附件图片">
                            <el-upload :action="addFile" :on-change="handleOnChange" :file-list="myPurchaseFile" :limit="5" :on-exceed="uploadOverrun" :auto-upload="false" :on-remove="handleRemove" accept=".jpg, .jpeg, .png, .gif" list-type="picture-card">
                                <i class="el-icon-plus" style="width:80px;height:80px;" />
                            </el-upload>
                        </el-form-item>
                    </el-form>

                    <el-table :data="chooseTableList" border class="table" max-height="320" ref="multipleTable">
                        <el-table-column prop="id" label="ID" width="50px" fixed="left"></el-table-column>
                        <el-table-column prop="applierName" label="申请人" width="120" fixed="left"></el-table-column>
                        <el-table-column prop="applyCode" label="货品申请编号" width="300"></el-table-column>
                        <el-table-column prop="houseName" label="仓库名称"></el-table-column>
                        <el-table-column prop="auditName" label="审核人"></el-table-column>
                        <el-table-column prop="auditRemark" label="审核备注"></el-table-column>
                        <el-table-column prop="createTime" label="创建时间" :formatter="dateFormatA" width="140px"></el-table-column>
                    </el-table>
                </div>
                <div style="padding:20px 20px;border:1px solid #ddd;" v-if="activeStep==2">
                    <el-table :data="formResult" border class="table" max-height="320" ref="multipleTable">
                        <el-table-column prop="purchaseOrderId" label="采购单id" width="100" fixed="left"></el-table-column>
                        <el-table-column prop="skuInfo.skuCode" label="商品skuCode"></el-table-column>
                        <el-table-column prop="skuInfo.commodityName" label="商品名称"></el-table-column>
                        <el-table-column prop="skuInfo.propertyValue" label="商品属性"></el-table-column>
                        <!-- <el-table-column prop="skuId" label="商品skuid"></el-table-column> -->
                        <el-table-column prop="buyNumber" label="sku采购数量"></el-table-column>
                        <el-table-column prop="skuInfo.salePrice" label="销售价格"></el-table-column>
                        <el-table-column label="sku采购单价">
                            <template slot-scope="scope">
                                <el-input type="number" v-model.trim="scope.row.applyPrice" placeholder="请输入采购单价"> </el-input>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>

            </div>

            <span slot="footer" class="dialog-footer" v-if="activeStep==1">
                <el-button type="primary" @click="addApplyVisible=false">取消</el-button>
                <el-button type="primary" @click="nextStep">下一步</el-button>
            </span>
            <span slot="footer" class="dialog-footer" v-if="activeStep==2">
                <el-button type="primary" @click="addApplyVisible=false">取消</el-button>
                <el-button type="primary" @click="confSubmit">提交</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "../../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import Service from "@/script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";
import "../css/index.css";

let vm;
export default {
    filters: {
        statusFilter(value) {},
    },
    data() {
        return {
            addApplyVisible: false, //主弹窗显示
            chooseTableList: [],
            activeStep: 1,
            orderForm: {
                expectedArriveTime: null,
                // id: null,
                name: null,
                // purseOrderId: null,
                relationGoodsApplyIds: [],
                remark: null,
                purchaseNo: null,
                purchaseFile: null,
            },
            myPurchaseFile: [], //附件图片信息
            addFile: Service.addFile + globalData.userInfo.userAccount,
            formResult: [], //第一步返回的
        };
    },
    beforeCreate() {
        vm = this;
    },
    methods: {
        addApply(listData) {
            this.addApplyVisible = true;
            this.activeStep = 1;
            this.chooseTableList = listData;
            this.orderForm = {
                 expectedArriveTime: null, 
                name: null, 
                relationGoodsApplyIds: [],
                remark: null,
                purchaseNo: null,
                purchaseFile: null,
            };
            this.myPurchaseFile=[];
        },

        nextStep() {
            if (this.orderForm.name == null || this.orderForm.name == "") {
                this.$message.error("请填写采购单名称");
                return;
            }
            if (
                this.orderForm.purchaseNo == null ||
                this.orderForm.purchaseNo == ""
            ) {
                this.$message.error("请填写采购单号");
                return;
            }
            if (
                this.orderForm.expectedArriveTime == null ||
                this.orderForm.expectedArriveTime == ""
            ) {
                this.$message.error("请选择预计到货日期");
                return;
            }
            if (this.myPurchaseFile.length > 0) {
                let imgs = this.myPurchaseFile.map((item) => {
                    return item.url;
                });
                this.orderForm.purchaseFile = imgs.join(",");
            }

            let temparr = [];
            this.chooseTableList.forEach((e) => {
                temparr.push(e.id);
            });
            this.orderForm.relationGoodsApplyIds = temparr;

            wmsApi
                .$axioswmsPurchasepreCreateNewPurchaseOrder(this.orderForm)
                .then((res) => {
                    if (res.data.errno == 0) {
                        console.log(res.data.data);
                        this.activeStep = 2;
                        this.formResult = res.data.data;
                    } else {
                        this.$message.error(res.data.data);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        confSubmit() {
            let reqData = [];
            let boo = true;
            this.formResult.forEach((e) => {
                if (
                    e.applyPrice == null ||
                    e.applyPrice == "" ||
                    e.applyPrice < 0
                ) {
                    boo = false;
                }
                let tempData = {
                    purchaseOrderId: e.purchaseOrderId,
                    skuId: e.skuId,
                    applyPrice: e.applyPrice,
                };
                reqData.push(tempData);
            });
            if (!boo) {
                this.$message.error("请输入sku采购单价，且不能小于0");
                return;
            }

            wmsApi
                .$axioswmsPurchasefinishPurchaseOrderSkuPrice(reqData)
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.addApplyVisible = false;
                        this.$message.success("操作成功");
                    } else {
                        this.$message.error(res.data.data);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        uploadOverrun: function () {
            this.$message({
                type: "error",
                message: "上传文件个数超出限制!最多上传5张图片!",
            });
        },
        handleRemove: function (file, fileList) {
            console.log(file, fileList);
            this.myPurchaseFile = fileList;
        },
        handleOnChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if (file.raw) {
                console.log("上传文件大小" + file.raw.size);
                let param = new FormData();
                param.append("createAccount", globalData.userInfo.userAccount);
                param.append("file", file.raw);
                Service.$ajaxAddFile(param).then((res) => {
                    console.log(res);
                    if (res.data.errno == 0) {
                        console.log(res);
                        file.url = res.data.data.fileUrl;
                        this.myPurchaseFile = fileList;
                        console.log(this.myPurchaseFile);
                    }
                });
            }
        },
    },
};
</script>
<style   >
.el-form-item__content .el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 90px;
}
.el-upload-list .el-upload-list__item {
    width: 80px;
    height: 80px;
}
</style>>

 
